<script lang="ts">
  import { Router, Route, navigate } from 'svelte-routing';
  import Toasts from './components/toast/Toasts.svelte';
  import Login from './Login.svelte';
  import Redirect from './Redirect.svelte';
  import PageLayout from './components/PageLayout.svelte';
  import Routing from './Routing.svelte';
  import { initializeLoginState } from './utils/login.service.js';
  import { initCognitoOAuthConfig } from './utils/cognito-auth-config.js';
  import Logout from './Logout.svelte';
  import { onMount } from 'svelte';
  import { OAuthSession } from './utils/oauth-session.js';
  import NoAccess from './NoAccess.svelte';

  let isLoading = true;
  let scopes: string[] = [];

  onMount(async () => {
    isLoading = true;
    const codeParam = new URLSearchParams(window.location.search).get('code');

    try {
      await initCognitoOAuthConfig();
      await OAuthSession.init(codeParam);
      await initializeLoginState();
    } catch (e) {
      console.error(e);
    }

    const isActiveSession = await OAuthSession.isActive();

    if (!isActiveSession) {
      OAuthSession.saveLocationBeforeLogin(window.location.href);
      navigate(`/login`, { replace: true });
    } else {
      scopes = await OAuthSession.getScopes();
    }

    isLoading = false;
  });
</script>

{#if !isLoading}
  <Router>
    <PageLayout {scopes}>
      <Route path="/login" component={Login} />
      <Route path="/logout" component={Logout} />
      <Route path="/" component={scopes.includes('redirect') ? Redirect : NoAccess} />
      <Route path="/routing" component={scopes.includes('routing') ? Routing : NoAccess} />
    </PageLayout>
  </Router>
{/if}

<Toasts />
